<template>
    <div class="sticky bg-slate-100 flex w-full px-2 md:px-4 lg:px-8 z-10" style="top:0rem; padding: 1rem 0rem;">
        <div class="w-full" :class="classObj">
            <div class="flex justify-between w-full sticky">

                <!-- SM - OPEN SIDEBAR BUTTON -->

                <div class="flex items-center gap-4">

                    <feather-icon class="sm:inline-flex lg:hidden cursor-pointer p-0 " icon="MenuIcon"
                        @click="openSidebar" />
                    <transition :name="routerTransition">

                        <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                            class="router-header flex flex-wrap items-center md:flex gap-4">

                            <div class="content-area__heading flex items-center">
                                <h3 class="mr-2 text-2xl text-slate-900 flex relative">{{ routeTitle }}</h3>
                            </div>

                            <!-- <config-dash-board class="hidden lg:block" style="z-index: 4000000;" v-if="routeTitle === 'Dashboard'" /> -->
                            <div v-if="routeTitle === 'Dashboard'" class="flex items-center">
                                 <config-dash-board class="hidden lg:block" style="z-index: 4000000;" v-if="routeTitle === 'Dashboard'" />
                                <div v-if="configDashboard" class="flex">
                                <div class="custom-btn cursor-pointer px-3 px-lg-5 py-2 text-center"
                                    @click="$store.commit('dashboard/SHOW_WIDGETS_CARD', true)"
                                >
                                    &#43; Add
                                </div>
                                <div class="custom-btn cursor-pointer px-3 px-lg-5 py-2 text-center my-2 sm:my-0"
                                    @click="resetWidgets()"
                                >
                                    &#10227; Reset
                                </div>
                                <div class="custom-btn cursor-pointer px-3 px-lg-5 py-2 text-center"
                                    @click="$store.commit('dashboard/SET_CONFIG_DASHBOARD', false)"
                                    >
                                    &#10003; Done
                                </div>
                                </div>
                            </div>
                        </div>

                    </transition>

                </div>

                <div class="flex items-center gap-4">

                    <apps-drop-down />

                    <profile-drop-down />

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import AppsDropDown from "./components/UnifiedMenuCustom.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import themeConfig from "@/../themeConfig.js";
import VxUserBreadcrumb from "../VxUserBreadcrumb.vue";
import ConfigDashBoard from "./components/ConfigDashBoard.vue";
import Notification from "./components/Notification.vue";

import gsap from "gsap";


export default {
    name: "the-navbar-vertical",
    props: {
        navbarColor: {
            type: String,
            default: "#fff",
        },
    },
    data() {
        return {
            routerTransition: themeConfig.routerTransition || "none",
            // routeTitle        : this.$route.meta.pageTitle
            configUserDashboard: false,
            showConfigIconTip: false,
        };
    },

    components: {
        Bookmarks,
        // I18n,
        SearchBar,
        // CartDropDown,
        NotificationDropDown,
        ProfileDropDown,
        VxUserBreadcrumb,
        AppsDropDown,
        ConfigDashBoard,
        Notification,
    },
    computed: {
        routeTitle() {
            return this.$route.meta.pageTitle;
        },
        usersData() {
            return this.$store.state.users.data;
        },
        navbarColorLocal() {
            return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
                ? "#10163a"
                : this.navbarColor;
        },
        verticalNavMenuWidth() {
            return this.$store.state.verticalNavMenuWidth;
        },
        textColor() {
            return {
                "text-white":
                    (this.navbarColor !== "#10163a" &&
                        this.$store.state.theme === "dark") ||
                    (this.navbarColor !== "#fff" && this.$store.state.theme !== "dark"),
            };
        },
        windowWidth() {
            return this.$store.state.windowWidth;
        },

        // NAVBAR STYLE
        classObj() {
            if (this.verticalNavMenuWidth === "default") return "navbar-default";
            else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
            else if (this.verticalNavMenuWidth) return "navbar-full";
        },
        userBoards() {
            return this.$store.state.boards.userLevelBoards;
        },
        notificationPanelPopup() {
            return this.$store.state.modals.notificationPanelPopup;
        },
        appSubscriptions() {
            return this.$store.state.users.appSubscriptions;
        },
        configDashboard() {
            return this.$store.state.dashboard.configDashboard;
        },
    },
    watch: {
        configUserDashboard(val) {
            this.$store.commit("dashboard/SET_CONFIG_DASHBOARD", val);
        },
        notificationPanelPopup(newVal) {
            if (newVal) {
                window.addEventListener("click", this.handleClickOutside);
            }
        },
    },
    methods: {
        showSidebar() {
            this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
        },
        handleClickOutside(event) {
            var deviceWidth = window.innerWidth;
            const popup =
                deviceWidth >= 768
                    ? this.$refs.notificationpanel
                    : this.$refs.notificationpanelSmall;
            if (!popup.contains(event.target)) {
                this.$store.commit("modals/OPEN_NOTIFICATION_POPUP", false);
                window.removeEventListener("click", this.handleClickOutside);
            }
        },

        openSidebar() {
            const tl = gsap.timeline({
                defaults: {
                    duration: 0.2,
                    ease: "rough",
                    repeat: 0,
                },
            });

            tl.fromTo(
                '#sidebarOverlay',
                0.2,
                { zIndex: 3000, opacity: 0 },
                { opacity: 0.5 },
            )

            tl.to(
                '#mobileSidebar',
                0.2,
                { marginLeft: "4rem" },
            )
        },
        resetWidgets() {
            this.$root.$refs.Main.setDefaultDashboardConfig();
        },
    },
};
</script>

<style lang="scss" scoped>
.blinker {
    top: 0.75em;
    right: -0.5em;

    &-color {
        background: rgba(var(--vs-primary, "#F2C244"), 1) !important;
    }

    &-details {
        background: #fae0a0;
        left: 6em;
        top: 2em;
        width: 20em;
        border-radius: 8px;
    }
}

@media (min-width: 1201px) {
    .main-vertical .vx-navbar-wrapper {
        /* width: calc(100% - 260px); */
        /* width: 100%; */
        /* padding-left: calc(100% - 500px); */
    }

    /* .vs-navbar {
    background: #F8F8F8 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    opacity: 1;
  } */

    .navbar-floating .vx-navbar {
        padding-left: 0;
        padding-right: 0;
    }
}
</style>
